import { TenantSelect } from "./TenantSelect";

export default TenantSelect;
